import { render, staticRenderFns } from "./RatingAdvancedProps.vue?vue&type=template&id=1a203821&scoped=true&"
import script from "./RatingAdvancedProps.vue?vue&type=script&lang=js&"
export * from "./RatingAdvancedProps.vue?vue&type=script&lang=js&"
import style0 from "./RatingAdvancedProps.vue?vue&type=style&index=0&id=1a203821&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a203821",
  null
  
)

export default component.exports